import { render, staticRenderFns } from "./Kinkekaart.vue?vue&type=template&id=33482879"
import script from "./Kinkekaart.vue?vue&type=script&lang=js"
export * from "./Kinkekaart.vue?vue&type=script&lang=js"
import style0 from "./Kinkekaart.vue?vue&type=style&index=0&id=33482879&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports